export default __webpack_public_path__ + "static/media/Facebook.28af8a9a.svg";